import { useEffect } from "react";

const MOBILE_VIEWPORT = "width=device-width, initial-scale=1, shrink-to-fit=no";
const DEFAULT_VIEWPORT = "width=1440, initial-scale=0, shrink-to-fit=no";

const ensureViewportTag = () => {
    let viewport = document.querySelector('meta[name="viewport"]');

    if (!viewport) {
        viewport = document.createElement("meta");
        viewport.setAttribute("name", "viewport");
        document.head.appendChild(viewport);
    }

    return viewport;
};

const useMobileViewport = () => {
    useEffect(() => {
        const viewport = ensureViewportTag();
        const previousContent = viewport.getAttribute("content");

        viewport.setAttribute("content", MOBILE_VIEWPORT);

        return () => {
            viewport.setAttribute("content", previousContent || DEFAULT_VIEWPORT);
        };
    }, []);
};

export default useMobileViewport;